import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChatFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 2C17.5 2 22 6.5 22 12C22 13.8 21.5 15.5 20.7 17L22 22L17 20.6C15.5 21.5 13.8 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2ZM5.90002 12C5.90002 11.3925 6.39251 10.9 7.00002 10.9C7.60754 10.9 8.10002 11.3925 8.10002 12C8.10002 12.6075 7.60754 13.1 7.00002 13.1C6.39251 13.1 5.90002 12.6075 5.90002 12ZM15.9 12C15.9 11.3925 16.3925 10.9 17 10.9C17.6075 10.9 18.1 11.3925 18.1 12C18.1 12.6075 17.6075 13.1 17 13.1C16.3925 13.1 15.9 12.6075 15.9 12ZM12 10.9C11.3925 10.9 10.9 11.3925 10.9 12C10.9 12.6075 11.3925 13.1 12 13.1C12.6075 13.1 13.1 12.6075 13.1 12C13.1 11.3925 12.6075 10.9 12 10.9Z",
		fill: "currentColor"
	})
});
export default SvgChatFilled;
